<template>
  	<div class="module_page page_content institution payment_plans add_coupon transactions_list" aria-label="Institution Summary view content page">

    <div class="row page-heading">
      <div class="col-2 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-10 right-container pg_hd_rgt_sec">
        <template v-if="!showLoader">
          <div class="row pg_hd">
            <div class="col-5 hd">
              <div class="hd_ic">
                <span class="ic ic22-transaction"></span>
              </div>
              <div class="ace_sec_txt hd_txt">
                <span class="hd_txt_inner">
                  {{ $t('transactions') }}
                </span>
                <span class="hd_info">
                  (<select v-model="count" class="count">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  / {{ totalElements }})
                  <!--
                  {{ $t('showing') }}: {{count}} out of {{ totalElements }}
                  -->
                </span>
              </div>
            </div>
            <div class="col-7 btn_container">
              <div class="row">

                <div class="col-7 btn_container pagination_sty3">
                  <b-button
                    @click="prev()"
                    class="btn btn_trans"
                    :disabled="transactions.first || transactions.empty"
                    :title="$t('previousPage')" :aria-label="$t('previousPage')"
                    v-b-tooltip.hover><span class="ic2_arr_pre3" aria-hidden="true"></span></b-button>
                  <span class="page_info">
                    <b-dropdown
                      variant="outline-secondary"
                      class="pagination_dropdown"
                      :disabled="transactions.empty"
                    >
                    <template #button-content class="ic_btn btn_pg_switch">
                      <span class="current">{{ page + 1 }}</span>
                      <span class="total">({{ totalPages }})</span>
                    </template>
                      <b-dropdown-item
                        v-for="p in totalPages"
                        :key="p"
                        @click="goToPage(p)"
                        :active="p === selectedPageUI"
                      >
                        Page {{ p }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                  <b-button
                    @click="next()"
                    class="btn btn_trans"
                    :disabled="transactions.next || transactions.empty"
                    :title="$t('nextPage')" :aria-label="$t('nextPage')"
                    v-b-tooltip.hover><span class="ic2_arr_next3" aria-hidden="true"></span></b-button>
                </div>
                <div class="col-5 btn_bk_e-com" style="margin-right: 30px; margin-left: 6px;">
                  <b-button class="btn" @click="returnToEcommerce()">
                    {{ $t('backToEcom') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

	    <div class="page_content_container" :class="isNotCustomAdmin ? '' : 'no_left_nav'">
	      	<institution-menu :uuid="uuid" :active="'paymentgateway'"></institution-menu>

		      <div class="row pg_content">
			      <div class="col-12">
			          <b-jumbotron style="padding-top: 10px;">
                  <template v-if="!showLoader">
                    <div class="">
                      <div class="mt-2" v-if="transactions.content && transactions.content.length > 0">
                        <div class="row plan_row" v-for="transaction in transactions.content">
                          <div class="col-12">

                            <div class="row">

                              <div class="col-xl-10 col-lg-9 col-md-8 col-sm-12 col-xm-12">
                                <div class="row">

                                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xm-12">
                                    <div class="row col_row">
                                      <div class="col-12 ace_sec_txt title">
                                        {{transaction.userObject.firstName}} {{transaction.userObject.lastName}}
                                      </div>
                                    </div>
                                    <div class="row col_row" v-if="transaction.programGuide">
                                      <div class="col-12 ace_sec_txt">Program: {{transaction.programGuide.title}}</div>
                                    </div>
                                  </div>

                                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xm-12">
                                    <div class="row col_row" v-if="transaction.pricingPlanLearner">
                                      <div class="col-12 ace_sec_txt">Plan: {{transaction.pricingPlanLearner.name}} (${{transaction.pricingPlanLearner.price.toFixed(2)}})</div>
                                    </div>
                                    <div class="row col_row">
                                      <div class="col-6 ace_sec_txt">
                                        Paid: ${{transaction.price.toFixed(2)}}
                                      </div>
                                      <div class="col-6 ace_sec_txt">
                                        {{getDateString(transaction.lastUpdatedTime)}}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xm-12">
                                    <div class="row col_row">
                                      <div class="col-12 ace_sec_txt">
                                        {{transaction.userObject.email}}
                                      </div>
                                    </div>
                                    <div class="row col_row coupon_code" v-if="transaction.couponCode">
                                      <div class="col-12 ace_sec_txt">
                                        {{transaction.couponCode.code}}
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>

                              <div class="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xm-12 rgt_col">
                                <div class="row col_row">
                                  <div class="col-8 ace_sec_txt trans_status">
                                    <div class="status" :class="transaction.status">
                                      {{transaction.status}}
                                    </div>
                                  </div>
                                  <div class="col-4 action_menu_container">
                                    <div class="action">
                                      <!--
                                      <div class="dropdown">
                                        <button class="btn ic_btn" v-if="transaction.status === 'COMPLETED' || transaction.status === 'REFUNDED'">
                                          <span class="ic9-iconMore-0005"></span>
                                        </button>
                                        <button class="btn ic_btn inactive" v-else>
                                          <span class="ic9-iconMore-0005"></span>
                                        </button>
                                        <div class="dropdown-content">
                                          <div class="menu_item" v-if="transaction.status === 'COMPLETED'">
                                            <a href="javascript://" @click="showRefundModal(transaction)">Refund</a>
                                          </div>
                                          <div class="menu_item" style="" v-if="transaction.status === 'REFUNDED' && transaction.refundedAmount">
                                            <span>Refunded: ${{transaction.refundedAmount.toFixed(2)}}</span>
                                          </div>
                                          <div class="menu_item" v-if="transaction.receiptUrl">
                                            <a :href="transaction.receiptUrl" target="_blank">Show Receipt</a>
                                          </div>
                                        </div>
                                      </div>
                                      -->



                                      <b-dropdown
                                        right
                                        no-caret
                                        animation="animation"
                                        variant="link"
                                        ref="menuDropDown"
                                        :toggle-class="transaction.status === 'COMPLETED' || transaction.status === 'REFUNDED'
                                          ? 'ic_btn'
                                          : 'ic_btn inactive'">
                                        <!--
                                        <template slot="button-content">
                      										<span class="btn ic_btn">
                      											<span
                      												class="ic ic_more"
                      												:aria-label="$t('dropdownMenuAria')"
                      												:title="$t('moreActionBtnTitle')"
                      												v-b-tooltip.hover>
                      											</span>
                      										</span>
                      									</template>
                                        -->
                                        <template #button-content>
                                          <span class="ic9-iconMore-0005"></span>
                                        </template>
                                      	<b-dropdown-item
                                          v-if="transaction.status === 'COMPLETED'"
                                          @click="showRefundModal(transaction)"
                    											:aria-label="$t('refundAria')">
                    											{{ $t('refund') }}
                    										</b-dropdown-item>
                                        <b-dropdown-item
                                          v-if="transaction.status === 'REFUNDED' && transaction.refundedAmount"
                                          class="inactive"
                    											:aria-label="$t('refundedAria')">
                    												Refunded: ${{transaction.refundedAmount.toFixed(2)}}
                    										</b-dropdown-item>
                                        <b-dropdown-item
                                          v-if="transaction.receiptUrl"
                                          :href="transaction.receiptUrl"
                                          target="_blank"
                                          :aria-label="$t('showReceiptAria')">
                    												{{ $t('showReceipt') }}
                    										</b-dropdown-item>
                                      </b-dropdown>



                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>


                          </div>
                        </div>
                      </div>

                      <p class="text-center ace_sec_txt" v-if="!transactions.content || transactions.content.length === 0">No transactions found.</p>
                    </div>
                  </template>
                  <template v-if="showLoader">
                    <p class="text-center ace_sec_txt">Loading..</p>
                  </template>
			          </b-jumbotron>
			      </div>
		      </div>
	    </div>
      <!-- Refund Modal -->
      <div>
        <b-modal class="modal__v22_2 price_plan_modal add_plan_modal refund_modal" id="new-pricing-plan-modal-popup" ref="refundModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>


            <div slot="modal-header" class="row header-section w-100">
                <div class="col-8 hd">
              		<div class="ic_container">
    								<span class="ic ic22-transaction"></span>
    							</div>
                  <div class="hd_txt" v-if="refundModalFlag">
                    <span v-if="selectedTransaction && selectedTransaction.userObject">Refund Trasaction to {{selectedTransaction.userObject.firstName}} {{selectedTransaction.userObject.lastName}}</span>
                    <span v-if="selectedTransaction && !selectedTransaction.userObject">Refund Transaction</span>
                  </div>
      					</div>
                <div class="col-4 btn_container pr-0">
                  <button class="btn_close" aria-label="close" title="close the popup" @click="closeRefundModal">
                    <span class="ic-close"></span>
                  </button>
                </div>
            </div>

            <div v-if="refundModalFlag">


            <div class="row content_container d-flex justify-content-center">
              <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 form_section">

                <div class="row price_plan_sec">
                  <div class="col-12 sec_content">

                    <p v-if="showRefundError" class="text-red">{{refundErrorMessage}}</p>
                    <p>Refund may take 3-5 business days to show up in your customer's account.</p>

                    <div class="row sec_row fld_row">
                      <div class="col-12 fld_label">
                        <label class="label">Refund Amount</label>
                      </div>
                      <div class="col-12 fld_input">
                        <input v-model="refundObj.refundAmount">
                      </div>
                    </div>

                    <div class="row sec_row fld_row">
                      <div class="col-12 fld_label">
                        <label class="label">Reason*</label>
                      </div>
                      <div class="col-12 fld_input">
                        <select v-model="refundObj.reason">
                          <option value="requested_by_customer">Requested by the Customer</option>
                          <option value="duplicate">Duplicate</option>
                          <option value="fraudulent">Fraudulent</option>
                        </select>
                      </div>
                    </div>

                    <div class="row sec_row fld_row">
                      <div class="col-12 btn_container align-right">
                        <b-button v-if="refundModalFlag" class="btn" @click="refundTransaction()">refund</b-button>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="order_summary">
                  <div class="hd">Order Summary</div>
                  <div class="detials">
                    <p v-if="selectedTransaction && selectedTransaction.programGuide"> Program: {{selectedTransaction.programGuide.title}}</p>
                    <p v-if="selectedTransaction && selectedTransaction.pricingPlanLearner">Pricing Plan: {{selectedTransaction.pricingPlanLearner.name}} (${{selectedTransaction.pricingPlanLearner.price.toFixed(2)}})</p>
                    <p v-if="selectedTransaction"> Amount Charged: ${{selectedTransaction.price.toFixed(2)}}</p>
                    <p v-if="selectedTransaction && selectedTransaction.couponCode">Coupon Code Used: {{selectedTransaction.couponCode.code}}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </b-modal>
      </div>
      <!-- Refund Modal Ends -->

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import { PACKAGE } from '../../../package_constants'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Editor from '@tinymce/tinymce-vue'
import Datepicker from 'vuejs-datepicker'

var DisableDate = function (startDate) {
  const date = (startDate) ? new Date(startDate) : new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export default {
  name: 'institutionTransactions',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader,
    Editor,
    Datepicker
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      showLoader: false,
      transactions: [],
      page: 0,
      count: 20,
      totalElements: 0,
      totalPages: 0,
      selectedPage: 1,
      selectedTransaction: {},
      refundObj: {
        refundAmount: 0.0,
        reason: ''
      },
      showRefundError: false,
      refundErrorMessage: '',
      refundModalFlag: false
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadLogDashboardActivity',
      'loadInstitutionTransactions',
      'loadRefundTransaction'
    ]),
    returnToEcommerce () {
      return this.$router.push({ name: 'institutionPaymentGateway', params: { uuid: this.uuid } })
    },
    async loadInstitution () {
      this.showLoader = true
      await this.loadLogDashboardActivity({action: 'viewInstitutionSummaryView', page: 'institutionSummaryView', link: '', entityUuid: this.uuid})
      await this.loadInstitutionDetail(this.uuid)
      this.transactions = await this.loadInstitutionTransactions({page: this.page, count: this.count})
      this.totalElements = this.transactions.totalElements
      this.totalPages = this.transactions.totalPages
      this.showLoader = false
    },
    showRefundModal (transaction) {
      this.selectedTransaction = transaction
      this.refundObj.refundAmount = this.selectedTransaction.price.toFixed(2)
      this.$refs.refundModal.show()
      this.refundModalFlag = true
    },
    closeRefundModal () {
      this.selectedTransaction = {}
      this.showRefundError = false,
      this.refundErrorMessage = ''
      this.refundObj.refundAmount = 0.0
      this.refundObj.reason = ''
      this.refundModalFlag = false
      this.$refs.refundModal.hide()
    },
    async refundTransaction () {
      this.showRefundError = false,
      this.refundErrorMessage = ''
      if (this.refundObj.refundAmount > this.selectedTransaction.price) {
        this.showRefundError = true,
        this.refundErrorMessage = 'Refund amount cannot be greater than the price charged.'
      } else if (this.refundObj.refundAmount <= 0) {
        this.showRefundError = true,
        this.refundErrorMessage = 'Refund amount must greater than 0'
      } else if (!this.refundObj.reason) {
        this.showRefundError = true,
        this.refundErrorMessage = 'Please select a refund reason.'
      } else {
        this.showLoader = true
        await this.loadRefundTransaction({ transactionId: this.selectedTransaction.uuid, refundObj: this.refundObj})
        this.transactions = await this.loadInstitutionTransactions({page: this.page, count: this.count})
        this.closeRefundModal()
        this.showLoader = false
      }
    },
    async prev () {
      if (!this.transactions.first) {
        this.showLoader = true
        this.page -= 1
        this.transactions = await this.loadInstitutionTransactions({page: this.page, count: this.count})
        this.showLoader = false
      }
    },
    async next () {
      if (!this.transactions.last) {
        this.showLoader = true
        this.page += 1
        this.transactions = await this.loadInstitutionTransactions({page: this.page, count: this.count})
        this.showLoader = false
      }
    },
    async goToPage(uiPage) {
      if (uiPage === this.selectedPageUI) return
      this.showLoader = true
      this.selectedPageUI = uiPage     // UI page (1-based)
      this.page = uiPage - 1           // backend page (0-based)
      this.transactions = await this.loadInstitutionTransactions({
        page: this.page,
        count: this.count
      })
      this.totalPages = this.transactions.totalPages
      this.showLoader = false
    },
    getDateString (timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString()
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    }
  },
  watch: {
    async count (newCount) {
      this.page = 0                 // backend page reset
      this.selectedPageUI = 1       // UI reset to Page 1
      this.showLoader = true
      this.transactions = await this.loadInstitutionTransactions({
        page: this.page,
        count: newCount
      })
      this.totalPages = this.transactions.totalPages   // ✅ refresh total pages
      this.showLoader = false
    }
  }
}
</script>
<style>
.text-green {
  color: green;
}
.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionTransactions.vue